/**
 * AppFooter — SaaS footer with build version, copyright, and legal links.
 * Build ID is injected at compile time via vite.config.ts __BUILD_ID__.
 */

declare const __BUILD_ID__: string;
declare const __APP_VERSION__: string;

const CURRENT_YEAR = new Date().getFullYear();

export function AppFooter() {
  return (
    <footer className="hidden md:block border-t border-gray-200 bg-white text-xs text-gray-400 dark:bg-slate-900 dark:border-slate-800 dark:text-slate-500 py-4 px-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
        <span>&copy; {CURRENT_YEAR} Firebreak Solutions, Inc. All rights reserved.</span>
        <div className="flex items-center gap-4">
          <a href="/terms" className="hover:text-gray-600 dark:hover:text-slate-300 transition-colors">Terms</a>
          <a href="/privacy" className="hover:text-gray-600 dark:hover:text-slate-300 transition-colors">Privacy</a>
          <a href="/security" className="hover:text-gray-600 dark:hover:text-slate-300 transition-colors">Security</a>
          <span className="text-gray-300 dark:text-slate-600" title={`${__APP_VERSION__} (${__BUILD_ID__})`}>{__APP_VERSION__}</span>
        </div>
      </div>
    </footer>
  );
}
